export const AUTH_FAILED = 'AUTH_FAILED' as const;
export const MISSING_AUTH_PARAMS = 'MISSING_AUTH_PARAMS' as const;
export const AUTH_REQUIRED = 'AUTH_REQUIRED' as const;
export const FAILED_TO_CALL_GAME_ENGINE = 'FAILED_TO_CALL_GAME_ENGINE' as const;
export const PLAYER_BLOCKED = 'PLAYER_BLOCKED' as const;
export const GAME_NOT_SUPPORTED_FOR_DEVICE = 'GAME_NOT_SUPPORTED_FOR_DEVICE' as const;
export const TABLE_IS_CLOSED = 'TABLE_IS_CLOSED' as const;
export const TABLE_OCCUPIED = 'TABLE_OCCUPIED' as const;
export const INSUFFICIENT_FUNDS_FOR_ENTRY = 'INSUFFICIENT_FUNDS_FOR_ENTRY';
export const GAME_LOAD_FAILURE = 'GAME_LOAD_FAILURE' as const;
export const BAD_INTERNET_CONNECTION = 'BAD_INTERNET_CONNECTION' as const;
export const MISSING_AUTH_PARAMS_OPERATOR_ID = 'MISSING_AUTH_PARAMS_OPERATOR_ID' as const;
export const MISSING_AUTH_PARAMS_TOKEN = 'MISSING_AUTH_PARAMS_TOKEN' as const;
export const MISSING_AUTH_PARAMS_UID = 'MISSING_AUTH_PARAMS_UID' as const;
export const MISSING_AUTH_PARAMS_NICKNAME = 'MISSING_AUTH_PARAMS_NICKNAME' as const;
export const CURRENCY_MISMATCH = 'CURRENCY_MISMATCH'as const;

export const CODES = {
  [AUTH_FAILED]: 2026,
  [AUTH_REQUIRED]: 2022,
  [MISSING_AUTH_PARAMS_OPERATOR_ID]: 2008,
  [MISSING_AUTH_PARAMS_TOKEN]: 2009,
  [MISSING_AUTH_PARAMS_UID]: 2028,
  [MISSING_AUTH_PARAMS_NICKNAME]: 2029,
  [MISSING_AUTH_PARAMS]: 2031,
  [FAILED_TO_CALL_GAME_ENGINE]: 104,
  [PLAYER_BLOCKED]: 106,
  [GAME_NOT_SUPPORTED_FOR_DEVICE]: 202,
  [TABLE_IS_CLOSED]: 203,
  [TABLE_OCCUPIED]: 211,
  [INSUFFICIENT_FUNDS_FOR_ENTRY]: 212,
  /*
    codes related to discontinued videochat bj:
      [DENIED_CAMERA_ACCESS]: 311,
      [DENIED_MICROPHONE_ACCESS]: 312,
      [AGORA_ERROR]: 313,
      [VIDEO_MODERATION_KICK]: 314,
      [VIDEO_MODERATION_BAN]: 315,
  */
  [GAME_LOAD_FAILURE]: 3001,
  [BAD_INTERNET_CONNECTION]: 208,
  [CURRENCY_MISMATCH]: 30088,
} as const;

export const missingAuthParamsErrorCodes = Object.entries(CODES)
  .filter(([ name, _code ]) => name.startsWith('MISSING_AUTH_PARAMS')).map(([ _name, code ]) => code);

export const ERRORS = {
  AUTH_FAILED,
  MISSING_AUTH_PARAMS,
  AUTH_REQUIRED,
  FAILED_TO_CALL_GAME_ENGINE,
  PLAYER_BLOCKED,
  GAME_NOT_SUPPORTED_FOR_DEVICE,
  TABLE_IS_CLOSED,
  TABLE_OCCUPIED,
  INSUFFICIENT_FUNDS_FOR_ENTRY,
  GAME_LOAD_FAILURE,
  BAD_INTERNET_CONNECTION,
  MISSING_AUTH_PARAMS_OPERATOR_ID,
  MISSING_AUTH_PARAMS_TOKEN,
  MISSING_AUTH_PARAMS_UID,
  MISSING_AUTH_PARAMS_NICKNAME,
  CURRENCY_MISMATCH,
  CODES,
} as const;
